import AdditionalPage from './additional-page';

export * from './additional-page';
export default AdditionalPage;
